import styled from 'styled-components/macro'

const CircledGreyStyle = styled.div`
    padding: ${props => props.verticalPadding}px 22px ${props => props.verticalPadding}px 22px;
    background-color: #EEEEEE;
    border-radius: 10px;
    align-items: center;
`

export {CircledGreyStyle};